import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CreateUpdateSalesProjectComponent } from './create-update-sales-project.component';
import { DxTooltipModule, DxToolbarModule, DxTextAreaModule, DxDataGridModule, DxSliderModule, DxButtonModule, DxPopupModule, DxTemplateModule, DxDropDownButtonModule, DxScrollViewModule, DxTabPanelModule, DxAccordionModule, DxDateBoxModule, DxTextBoxModule, DxAutocompleteModule, DxSelectBoxModule, DxTagBoxModule, DxCheckBoxModule, DxRangeSliderModule, DxFileUploaderModule, DxNumberBoxModule } from 'devextreme-angular';
import { MdbGlobalModule } from 'src/app/shared/mdb-global.module';
import { NewContactModule } from 'src/app/shared/new-contact/new-contact.module';
import { NewServiceSiteModule } from '../../employee-activities/forms/new-service-site/new-service-site.module';
import { NewCustomerModule } from '../../employee-activities/forms/new-customer/new-customer.module';
import { MarketCompaniesThatYouCompeteModule } from '../../market-analysis/market-companies-that-you-compete/market-companies-that-you-compete.module';

import { GooglePlaceModule } from 'ngx-google-places-autocomplete';
import { DinamicModalModule } from 'src/app/shared/dinamic-modal/dinamic-modal.module';
import { NewSalesRoundComponent } from '../new-sales-round/new-sales-round.component';


@NgModule({
  declarations: [
    CreateUpdateSalesProjectComponent,
    NewSalesRoundComponent,

  ],
  imports: [
    CommonModule,
    MdbGlobalModule,
    DxTextAreaModule,
    DxDataGridModule,
    DxSliderModule,
    DxButtonModule,
    DxPopupModule,
    DxTemplateModule,
    DxDropDownButtonModule,
    DxScrollViewModule,
    DxTabPanelModule,
    DxAccordionModule,
    DxDateBoxModule,
    DxTextBoxModule,
    DxAutocompleteModule,
    DxSelectBoxModule,
    DxTagBoxModule,
    DxCheckBoxModule,
    DxRangeSliderModule,
    DxFileUploaderModule,
    DxNumberBoxModule,
    NewContactModule,
    NewCustomerModule,
    NewServiceSiteModule,
    MarketCompaniesThatYouCompeteModule,
    GooglePlaceModule,
    DxToolbarModule,
    DinamicModalModule,
    DxTooltipModule,
  ],
  exports:[CreateUpdateSalesProjectComponent, NewSalesRoundComponent]
})
export class CreateUpdateSalesProjectModule { }
